// The palette lives in ./commandPalette, split by concern; this keeps its import path.
export { CommandPalette, type CommandPaletteProps } from "@/components/commandPalette/CommandPalette";
export { default } from "@/components/commandPalette/CommandPalette";
